import { mapMutations } from 'vuex';

export default {
  props: {
    /**
     * The field name.
     */
    name: {
      type: String,
      required: true,
    },

    /**
     * The field value.
     */
    value: {
      required: false,
      default: () => [],
    },

    /**
     * The options for the select field. Should be a array of objects with id and name attributes.
     */
    options: {
      type: Array,
      required: false,
      default: () => [],
    },

    /**
     * The base key to translate the form.
     */
    translation: {
      type: String,
      required: false,
    },

    /**
     * If the input has label.
     */
    hasLabel: {
      type: Boolean,
      required: false,
    },

    /**
     * If the input has error.
     */
    error: {
      type: String,
      required: false,
    },

    /**
     * If the input has error.
     */
    insideForm: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * If the input accepts many options.
     */
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * If the input is disabled.
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * If user can filter options.
     */
    filterable: {
      type: Boolean,
      default: true,
    },

    /**
     * If options come from server.
     */
    remote: {
      type: Boolean,
      default: false,
    },

    /**
     * Method to fetch options from server.
     */
    remoteMethod: {
      type: Function,
      required: false,
      default: () => {},
    },

    /**
     * If it is loading options from server.
     */
    loading: {
      type: Boolean,
      default: false,
    },

    /**
     * The component to add another option.
     */
    quickForm: {
      type: Object,
      required: false,
    },
    hasButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    buttonHandler: {
      type: Function,
      default: () => {},
      required: false,
    },
    buttonLabel: {
      type: String,
      required: false,
    },
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * This method will be called when input event is fired.
     *
     * @param  {String} name    The field name.
     */
    onInput(name) {
      return (value) => {
        this.$emit('change', name, value);
      };
    },

    onQuickFormClick() {
      this.setModalContent(this.quickForm);
      this.toggleModal(true);
    },
  },

  /**
   * This function will be called to render the HTML.
   *
   * @param  {Function} h    Mandatory for vue to render JSX.
   */
  /* eslint no-console: ["error", { allow: ["log", "error"] }] */
  // eslint-disable-next-line
  render (h) {
    let value = (this.multiple === true && this.value === '') ? [] : this.value;
    if (typeof this.value !== 'object' && this.value !== '') {
      value = value.toString();
    }

    const options = Object.keys(this.options).map(k => (
      <el-option
        value={this.options[k].id.toString()}
        label={this.options[k].name.toString()}
        disabled={this.options[k].disabled}
        key={this.options[k].id}
      >

      </el-option>
    ));

    const select = (
      <el-select
        ref={this.name}
        value={value}
        loading={this.loading}
        filterable={this.filterable}
        disabled={this.disabled}
        onInput={this.onInput(this.name)}
        name={this.name}
        multiple={this.multiple}
        remote={this.remote}
        remoteMethod={this.remoteMethod}
        placeholder={
          this.translation
            ? this.$t(`${this.translation}.placeholder`)
            : this.name
        }
      >
        {options}
      </el-select>
    );

    if (!this.insideForm) {
      return select;
    }

    let label = null;
    if (this.label) {
      label = this.translation ? this.$t(`${this.translation}.label`) : this.name;
    }
    if (this.hasLabel) {
      label = this.translation ? this.$t(`${this.translation}.label`) : this.name;
    }

    return (
      <el-form-item
        error={this.error}
        label={label}
      >
        {select}
        {
          this.hasButton ?
          <el-button onClick={this.buttonHandler} class="small" style="margin-left:5px"> 
          {this.buttonLabel}
          </el-button> :
          null
        }
        {
          this.quickForm ?
          <el-button
            onClick={this.onQuickFormClick}
            icon='el-icon-plus'
            class='small'
            style='margin-left:5px'
          >
          </el-button> :
          null
        }
      </el-form-item>
    );
  },
};



// WEBPACK FOOTER //
// ./src/app/components/form/select/select.jsx